// extracted by mini-css-extract-plugin
export default {"footerContainer":"Z1iddQv2naK8yl8jrpxT","buttons":"g3qgapDN4fwdcEy0rI9d","button":"Qa8WPwSaC_mnPqIU4h7t"};